/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    setAnotherMarket,
    setUnderwriter,
    resetQuotes,
    resetQuoteVariation,
    issueQuoteVariation
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step05c from '../../../components/pages/Quote/Step05c/Step05c'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        subjectivities: state.step05.subjectivities,
        marketStatus: state.step05.market,
        underwriterStatus: state.step05.underwriter,
        step05c: state.step05,
        request_rate: state.step05,
        fullQuote: get(state.quote, 'full.response.quote.stockBusinessAssets', {}),
    }
}

export default connect(
    mapStateToProps,
    {
        quote: 'The QUOTE! Step02',
        setAnotherMarket: setAnotherMarket,
        setUnderwriter: setUnderwriter,
        issueQuoteVariation: issueQuoteVariation,
        resetQuotes: resetQuotes,
        resetQuoteVariation: resetQuoteVariation,
    }
)(Step05c)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step05c.tsx